import { OrganizationImageTranslationDisplay } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from './actions';

const stateFactory =
  stateFactories.createInitialEntitiesStateFactory<EntityType<OrganizationImageTranslationDisplay>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminOrganizationImageTranslationReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminOrganizationImagesTranslation.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getAdminOrganizationImagesTranslation.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getAdminOrganizationImagesTranslation.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getAdminOrganizationImagesTranslation.reset.type]: actionsHandlers.handleGetManyReset,
  [actions.replaceAdminOrganizationImageTranslation.request.type]: actionsHandlers.handleUpdateOneRequest,
  [actions.replaceAdminOrganizationImageTranslation.success.type]: actionsHandlers.handleUpdateOneSuccess,
  [actions.replaceAdminOrganizationImageTranslation.failure.type]: actionsHandlers.handleUpdateOneFailure,
  [actions.replaceAdminOrganizationImageTranslation.reset.type]: actionsHandlers.handleUpdateOneReset,
});

export default adminOrganizationImageTranslationReducer;
